// @ts-ignore
/* eslint-disable */
import { request } from '../../request'

/** No comments are provided by the backend GET /assets */
export async function assetsControllerLibrary(
  // Param type generated by superposition
  params: API.AssetsControllerLibraryParams,
  options?: { [key: string]: any },
) {
  return request<any>('/assets', {
    method: 'GET',
    params: {
      // page has a default value: 1
      page: '1',
      // pageSize has a default value: 20
      pageSize: '20',
      ...params,
    },
    ...(options || {}),
  })
}

/** No comments are provided by the backend POST /assets */
export async function assetsControllerUpload(
  body: {},
  file?: File,
  options?: { [key: string]: any },
) {
  const formData = new FormData()

  if (file) {
    formData.append('file', file)
  }

  Object.keys(body).forEach((ele) => {
    const item = (body as any)[ele]

    if (item !== undefined && item !== null) {
      if (typeof item === 'object' && !(item instanceof File)) {
        if (item instanceof Array) {
          item.forEach((f) => formData.append(ele, f || ''))
        } else {
          formData.append(ele, JSON.stringify(item))
        }
      } else {
        formData.append(ele, item)
      }
    }
  })

  return request<any>('/assets', {
    method: 'POST',
    data: formData,
    requestType: 'form',
    ...(options || {}),
  })
}

/** No comments are provided by the backend GET /assets/${param0} */
export async function assetsControllerServe(
  // Param type generated by superposition
  params: API.AssetsControllerServeParams,
  options?: { [key: string]: any },
) {
  const { hash: param0, ...queryParams } = params
  return request<any>(`/assets/${param0}`, {
    method: 'GET',
    params: { ...queryParams },
    ...(options || {}),
  })
}

/** No comments are provided by the backend DELETE /assets/${param0} */
export async function assetsControllerRemove(
  // Param type generated by superposition
  params: API.AssetsControllerRemoveParams,
  options?: { [key: string]: any },
) {
  const { hash: param0, ...queryParams } = params
  return request<any>(`/assets/${param0}`, {
    method: 'DELETE',
    params: { ...queryParams },
    ...(options || {}),
  })
}
